const AdminUsers = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
        <p className="text-gray-600">Manage system users and their permissions.</p>
      </div>

      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-500">User management interface coming soon...</p>
      </div>
    </div>
  )
}

export default AdminUsers